/**
 * Evidence Register API helper (GW-8066)
 *
 * GW-8630: this module previously fetched a mission's products via
 * `MissionsClient.getProducts()` (`GET /v1/missions/{missionId}/products`)
 * to locate and map a PROD-CORE-002 record for a given run. That route was
 * never implemented by gw-missions-api (confirmed dead — see PACT.md), so
 * the fetch/map path was permanently unreachable and has been removed.
 * `emptyEvidenceRegisterProduct` remains: it is the real, live fallback
 * `missionRunResultsSlice.ts` returns for PROD-CORE-002 today.
 */

import type { EvidenceRegisterProduct } from '@gw/ui/types';

/**
 * Honest empty PROD-CORE-002 assembly. `merkle_root: ''` is the documented
 * signal `EvidenceRegisterPage` uses to render its "not yet sealed" banner —
 * this is the correct representation of "no register content available yet",
 * not a fabricated placeholder.
 */
export function emptyEvidenceRegisterProduct(): EvidenceRegisterProduct {
  return {
    product_id: 'PROD-CORE-002',
    total_entry_count: 0,
    merkle_root: '',
    merkle_tree_depth: 0,
    grading_merkle_root: '',
    entries: [],
    pricing_fetched_at: new Date().toISOString(),
  };
}
